import * as API from '../api'
export const FETCH_INTERACTION = 'FETCH_INTERACTION'
export const FETCH_ATCCLASSIFICATION = 'FETCH_ATCCLASSIFICATION'
export const FETCHING_INTERACTION = 'FETCHING_INTERACTION'
export const FETCH_INTERACTION_ERROR = 'FETCH_INTERACTION_ERROR'
export const FETCH_INTERACTIONS = 'FETCH_INTERACTIONS'
export const FETCHING_INTERACTIONS = 'FETCHING_INTERACTIONS'
export const FETCH_INTERACTIONS_ERROR = 'FETCH_INTERACTIONS_ERROR'
export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const CHANGE_INTERACTION = 'CHANGE_INTERACTION'
export const DELETE_INTERACTION = 'DELETE_INTERACTION'
export const ADD_INTERACTION = 'ADD_INTERACTION'
export const EDIT_INTERACTION = 'EDIT_INTERACTION'
export const FORM_TOUCHED = 'FORM_TOUCHED'
export const NEW_FORM_INTERACTION = 'NEW_FORM_INTERACTION'
export const INTERACTION_FORM_ERROR = 'INTERACTION_FORM_ERROR'
export const CHANGE_PAGE = 'CHANGE_PAGE'
export const CHANGE_PER_PAGE = 'CHANGE_PER_PAGE'
export const CHANGE_ORDER_COLUMN = 'CHANGE_ORDER_COLUMN'
export const CHANGE_ORDER_DIRECTION = 'CHANGE_ORDER_DIRECTION'
export const RESET_STATE = 'RESET_STATE'

export const openModal = () => {
  return dispatch => {
    dispatch({ type: OPEN_MODAL })
  }
}

export const handleChangeInteraction = interaction => {
  return dispatch => {
    dispatch({ type: CHANGE_INTERACTION, interaction })
  }
}

const getDuplicateKeyField = errorMessage => {
  const [x, field = ''] = /collection: .* index: (.*)_/.exec(errorMessage) // eslint-disable-line
  return field
}

export const handleInteractionError = (res, dispatch) => {
  const { data: errorMessage = '' } = res

  switch (true) {
    case errorMessage.includes('duplicate key error'):
      dispatch({
        type: FORM_TOUCHED
      })
      dispatch({
        type: INTERACTION_FORM_ERROR,
        field: getDuplicateKeyField(errorMessage),
        message: `${getDuplicateKeyField(errorMessage)} já cadastrado.`
      })
      return Promise.reject(res)

    default:
      break
  }
}

export const fetchAtcClassification = () => {
  return dispatch => {
    API.interactions.getAtcClassifications().then((res = {}) => {
      const { data } = res
      dispatch({ type: FETCH_ATCCLASSIFICATION, atcClassification: data })
    })
  }
}

export const newFormInteraction = interaction => {
  return dispatch => {
    dispatch({ type: NEW_FORM_INTERACTION })
  }
}

export const setInteractionFormTouched = interaction => {
  return dispatch => {
    dispatch({ type: FORM_TOUCHED })
  }
}

export const closeModal = () => {
  return dispatch => {
    dispatch({ type: CLOSE_MODAL })
  }
}

export const restoreInteraction = id => {
  return dispatch => {
    dispatch({ type: FETCHING_INTERACTIONS })
    return API.interactions
      .restoreInteraction(id)
      .then(({ data }) => {
        dispatch({ type: EDIT_INTERACTION, interaction: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_INTERACTIONS_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleInteractionError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const handleChangePage = page => {
  return dispatch => {
    dispatch({ type: CHANGE_PAGE, page })
  }
}

export const handleChangePerPage = perPage => {
  return dispatch => {
    dispatch({ type: CHANGE_PER_PAGE, perPage })
  }
}

export const changeOrderColumn = column => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_COLUMN, column })
  }
}

export const changeOrderDirection = direction => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_DIRECTION, direction })
  }
}

export const resetState = () => {
  return dispatch => {
    dispatch({ type: RESET_STATE })
  }
}

export const fetchInteractions = options => {
  return dispatch => {
    dispatch({ type: FETCHING_INTERACTIONS })
    return API.interactions
      .getInteractions(options)
      .then((res = {}) => {
        const { data } = res

        dispatch({
          type: FETCH_INTERACTIONS,
          interactions: data.items,
          length: data.length,
          page: data.page,
          order: data.order,
          rowsPerPage: data.rowsPerPage
        })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_INTERACTIONS_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const deleteInteraction = id => {
  return dispatch => {
    dispatch({ type: FETCHING_INTERACTIONS })
    return API.interactions
      .deleteInteraction(id)
      .then(({ data: interaction }) => {
        dispatch({ type: DELETE_INTERACTION, interaction })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_INTERACTIONS_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const addInteraction = interaction => {
  return dispatch => {
    dispatch({ type: FETCHING_INTERACTIONS })
    dispatch({ type: FETCHING_INTERACTION })
    return API.interactions
      .addInteraction(interaction)
      .then(({ data }) => {
        dispatch({ type: ADD_INTERACTION, interaction: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        handleInteractionError(response, dispatch)
        dispatch({
          type: FETCH_INTERACTIONS_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const editInteraction = interaction => {
  return dispatch => {
    dispatch({ type: FETCHING_INTERACTIONS })
    dispatch({ type: FETCHING_INTERACTION })
    return API.interactions
      .editInteraction(interaction)
      .then(({ data }) => {
        dispatch({ type: EDIT_INTERACTION, interaction: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_INTERACTIONS_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleInteractionError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const fetchInteraction = id => {
  return dispatch => {
    dispatch({ type: FETCHING_INTERACTION, clear: true })
    dispatch({ type: OPEN_MODAL })
    return API.interactions
      .getInteraction(id)
      .then(({ data }) => {
        dispatch({ type: FETCH_INTERACTION, interaction: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_INTERACTION_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/interactions.js